export const REBASE_RATE = 0.02355;
export const REBASE_RATE_1d = 2.2863;
export const REBASE_RATE_5d = 11.966;
export const APY = 383025.8;